import { Config } from '../../node_modules/@cvx/cal';

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'localStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '4d9db9f1-d2ad-4a86-ade2-cd6ee61829f6',
  // redirectUri: 'http://localhost:4200',
  redirectUri: 'https://arsaa-dev.azure.chevron.com/',
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
};

export const environment = {
  calConfig: calConfig,
  production: false,
  envName: 'dev',
  requestTimeout: 30000,
  apiEndpoint: 'https://arsaa-api-dev.azure.chevron.com/',
  webUrl: 'https://arsaa-dev.azure.chevron.com/',
};
